import React from "react";

export class ResponsibleDisclosureFR extends React.Component {
    render() {
        return (
            <>
                <p>
                    Dernière mise à jour: <b>29/03/2024</b>
                    <br />
                    <br />
                </p>

                <p>Chez DH Healthcare GmbH, nous croyons que la sécurité de nos systèmes, de notre réseau et de nos produits est primordiale.</p>

                <p>Nous y accordons beaucoup d'attention lors du développement et de la maintenance. Cependant, les vulnérabilités échappent parfois à la détection.</p>

                <p>
                    Si vous avez trouvé une vulnérabilité dans l'un de nos systèmes, veuillez nous en informer afin que nous puissions prendre des mesures le plus rapidement
                    possible. Nous souhaitons travailler avec vous pour mieux protéger nos données, nos utilisateurs et nos systèmes.
                </p>

                <p>
                    Nous avons donc opté pour une politique de divulgation coordonnée des vulnérabilités (également appelée «Divulgation Responsable») afin que vous puissiez nous
                    informer lorsque vous découvrez une vulnérabilité.
                </p>

                <p>Cette politique de divulgation responsable s'applique aux systèmes suivants, maintenus par DH Healthcare GmbH:</p>
                <ul>
                    <li>
                        <a href="https://www.dobcomed.com" target="_blank" rel="noreferrer">
                            https://www.dobcomed.com
                        </a>
                    </li>
                    <li>
                        <a href="https://secure.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://secure.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://france.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://france.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://norway.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://norway.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swiss.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swiss.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://germany.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://germany.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://latem.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://latem.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://brazil.imaging.dedalus.com" target="_blank" rel="noreferrer">
                            https://brazil.imaging.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://austria.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://austria.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swisscom.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swisscom.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://labs.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://labs.pacsonweb.com
                        </a>
                    </li>

                    <li>
                        <a href="https://secure.risonweb.com" target="_blank" rel="noreferrer">
                            https://secure.risonweb.com
                        </a>
                    </li>
                </ul>

                <p>
                    En cas de doute, veuillez nous contacter pour clarifier les choses via <a href="mailto:infosec@dobcomed.com">infosec@dobcomed.com</a>
                </p>

                <h2>Ce que nous vous demandons</h2>

                <p>Si vous découvrez une vulnérabilité dans l'un de nos systèmes, nous vous demandons de:</p>

                <ul>
                    <li>
                        Signalez la vulnérabilité dès que possible après la découverte. Envoyez vos résultats à <a href="mailto:infosec@dobcomed.com">infosec@dobcomed.com</a>.
                    </li>
                    <li>
                        Fournir suffisamment d'informations pour reproduire la vulnérabilité afin que nous puissions résoudre le problème le plus rapidement possible. Normalement,
                        l'URL du système affecté et une description de la vulnérabilité sont suffisantes, mais pour des vulnérabilités plus complexes, davantage peut être
                        nécessaire.
                    </li>
                    <li>
                        Laissez vos coordonnées afin que DH Healthcare GmbH puisse vous contacter pour travailler ensemble pour un résultat sûr. Laissez au moins votre nom, votre
                        adresse e-mail et / ou votre numéro de téléphone. Le signalement sous un pseudonyme est possible, mais assurez-vous que nous pouvons vous contacter si nous
                        avons des questions supplémentaires.
                    </li>
                    <li>Confirmez que vous avez agi et que vous continuerez d'agir conformément à la présente politique de divulgation responsable.</li>
                </ul>

                <h2>Règles que vous devez suivre</h2>

                <ul>
                    <li>
                        Ne partagez pas d'informations sur le problème de sécurité avec d'autres personnes avant que le problème ne soit résolu. Voir ci-dessous pour une éventuelle
                        publication.
                    </li>
                    <li>
                        N'exploitez pas la vulnérabilité en copiant, supprimant, adaptant ou visualisant des données inutilement. Ou, par exemple, en téléchargeant plus de données
                        que nécessaire pour démontrer la vulnérabilité.
                    </li>
                    <li>
                        N'appliquez aucune des actions suivantes:
                        <ul>
                            <li>Placement de logiciels malveillants</li>
                            <li>Copie, modification ou suppression de données dans un système.</li>
                            <li>Apporter des modifications au système.</li>
                            <li>Accès répété au système ou partage de l'accès avec d'autres.</li>
                            <li>Utilisation d'outils de numérisation automatisés.</li>
                            <li>Utilisation d'accès «force brute» aux systèmes.</li>
                            <li>Utilisation d’attaques (D)DOS, d’attaques physiques ou d'ingénierie sociale (phishing, vishing, spam, ...).</li>
                        </ul>
                    </li>
                    <li>Effacez immédiatement toutes les données obtenues grâce à la vulnérabilité dès que la vulnérabilité a été signalée à DH Healthcare GmbH.</li>
                    <li>
                        N'effectuez pas d'actions qui pourraient avoir un impact sur le bon fonctionnement du système, à la fois en termes de disponibilité et de performances, mais
                        aussi en termes de confidentialité et d'intégrité des données.
                    </li>
                </ul>

                <p>
                    Les actes en vertu de cette politique de divulgation responsable doivent se limiter à la réalisation de tests pour identifier les vulnérabilités potentielles et
                    au partage de ces informations avec DH Healthcare GmbH.
                </p>
                <p>
                    Si, après la suppression de la vulnérabilité, vous souhaitez publier des informations sur la vulnérabilité, nous vous demandons de nous en informer au moins un
                    mois avant la publication, et de nous donner la possibilité d'y répondre. Nous identifier dans une publication n'est possible qu'après avoir donné notre accord
                    explicite.
                </p>

                <h2>Ce que nous promettons</h2>

                <p>Si vous vous êtes conformé aux conditions ci-dessus de la politique de divulgation responsable et n'avez commis aucune autre violation,</p>
                <ul>
                    <li>nous n'engagerons aucune action en justice contre vous.</li>
                    <li>
                        nous répondrons à votre rapport dans les meilleurs délais, si possible dans un délai de 10 jours ouvrables, avec notre analyse du rapport et toute date
                        prévue de résolution.
                    </li>
                    <li>
                        nous traiterons votre rapport de manière confidentielle et ne partagerons pas vos données personnelles avec des tiers sans votre consentement, sauf si cela
                        est nécessaire pour se conformer à une obligation légale.
                    </li>
                    <li>nous vous tiendrons informés de l'avancement de la résolution du problème.</li>
                    <li>
                        nous tenons à vous remercier d'avoir signalé un problème de sécurité qui ne nous est pas encore connu en vous offrant la possibilité d'être répertorié dans
                        notre <a href="/POW3/HallOfFame">"Hall Of Fame"</a>.
                    </li>
                    <li>nous nous efforçons de résoudre tous les problèmes dans les meilleurs délais.</li>
                </ul>

                <p>Nous nous reservons le droit d'ignorer les rapports de mauvaise qualité.</p>
                <p>
                    Si vous avez des questions, nous vous encourageons à les adresser à <a href="mailto:infosec@dobcomed.com">infosec@dobcomed.com</a>.
                </p>
                <p>En cas de doute sur l'applicabilité de cette politique, veuillez d'abord nous contacter via cette adresse e-mail, pour demander une autorisation explicite.</p>
                <p>Nous nous réservons le droit de modifier le contenu de cette politique à tout moment ou de mettre fin à la politique.</p>
                <p>Ce texte est une œuvre dérivée de «Responsible Disclosure» de Floor Terra, utilisée sous une licence Creative Commons Attribution 3.0.</p>
            </>
        );
    }
}
